import classNames from 'classnames';
import { OverlayModel } from 'components/4-habitats';
import { Component } from 'components/Component';
import { usePageParam } from 'hooks/usePageParam';
import { useAppSelector } from 'store/hooks';
import styles from './IframePage.module.scss';

export interface IframePageProps {}

export const IframePage: React.FC<IframePageProps> = () => {
	const claimContent = useAppSelector((state) => state.claimContent);
	const { pages: wizardPages } = claimContent.wizardData ?? {};
	const { getPageParam } = usePageParam();
	const { content, name } =
		wizardPages?.find((page) => page.path.toLowerCase() === '/' + getPageParam()?.toLowerCase()) ?? {};

	return (
		// Always set to true due to the iFrames not needing a background
		<OverlayModel hasNoBackground={true}>
			<section
				className={classNames(styles.Iframe)}
				id={name}
			>
				{content?.map((component) => {
					return (
						<Component
							key={component?.inputId}
							{...component}
						/>
					);
				})}
			</section>
		</OverlayModel>
	);
};
